(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["katty-cartoon-drop-preview"]) return;
  try {
    
  const initializeCartoonSort = () => {
    document.querySelectorAll('[data-cartoon-drop-preview]').forEach(root => {
      const select = root.querySelector('[data-cartoon-sort]');
      const grid = root.querySelector('[data-cartoon-grid]');
      if (!select || !grid || select.dataset.ready === 'true') return;
      select.dataset.ready = 'true';
      const original = Array.from(grid.children).filter(child => child.classList.contains('kb-card'));
      const collectionLink = root.querySelector('[data-cartoon-collection-link]');
      const initialSort = select.value;
      const locale = document.documentElement.lang || 'es';
      const comparators = {
        'title-ascending': (a, b) => a.dataset.cartoonTitle.localeCompare(b.dataset.cartoonTitle, locale),
        'title-descending': (a, b) => b.dataset.cartoonTitle.localeCompare(a.dataset.cartoonTitle, locale),
        'price-ascending': (a, b) => Number(a.dataset.kbSortPrice) - Number(b.dataset.kbSortPrice),
        'price-descending': (a, b) => Number(b.dataset.kbSortPrice) - Number(a.dataset.kbSortPrice),
        'created-ascending': (a, b) => Number(a.dataset.kbSortCreated) - Number(b.dataset.kbSortCreated),
        'created-descending': (a, b) => Number(b.dataset.kbSortCreated) - Number(a.dataset.kbSortCreated)
      };
      const updateSort = () => {
        const cards = [...original];
        const comparator = comparators[select.value];
        if (comparator) cards.sort(comparator);
        else if (select.value !== initialSort) return;
        cards.forEach(card => grid.appendChild(card));
        if (collectionLink) {
          const url = new URL(collectionLink.href, document.baseURI);
          url.searchParams.set('sort_by', select.value);
          collectionLink.href = url.toString();
        }
      };
      select.addEventListener('change', updateSort);
      updateSort();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCartoonSort, { once: true });
  else initializeCartoonSort();
  document.addEventListener('shopify:section:load', initializeCartoonSort);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["katty-pack-emprende"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-kb-pack]').forEach(root => {
    const data = JSON.parse(root.querySelector('[data-kb-pack-config]').textContent);
    const size = Number(root.dataset.packSize);
    const money = n => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 }).format(n);
    const catalog = [...new Map((data.drops || []).flatMap(drop => drop.products || []).map(entry => [String(entry.product?.id), entry])).values()].filter(entry => entry.product?.id && entry.product?.variants?.some(v => entry.discountVariantIds?.includes(v.id)));
    let nextId = 1;
    let items = Array.from({ length: size }, (_, i) => ({ id: nextId++, qty: 1, kind: 'catalog', design: '', reference: '', weight: 250, color: 'Blanco', size: 'M', open: i === 0 }));
    const assigned = () => items.reduce((n, x) => n + x.qty, 0);
    const shirt = '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="m15 6 9 4 9-4 10 10-6 7-5-3v21H16V20l-5 3-6-7L15 6Z" fill="#fff" stroke="#7c756e" stroke-width="2"/></svg>';
    const card = (x, i) => `<details class="kb-pack__card" data-id="${x.id}" ${x.open ? 'open' : ''}><summary aria-expanded="${x.open}"><span class="kb-pack__thumb" data-thumb>${shirt}</span><span class="kb-pack__title"><b>Prenda ${i + 1} · ${x.qty} ${x.qty === 1 ? 'pieza' : 'piezas'}</b><small data-card-desc></small></span><span aria-hidden="true">⌄</span></summary><div class="kb-pack__body"><div class="kb-pack__fields"><div class="kb-pack__wide"><label>Diseño<select data-key="kind"><option value="catalog">Del catálogo</option><option value="custom">Personalizado</option></select></label></div><div class="kb-pack__wide" data-catalog-field><label>Diseño del catálogo<select data-key="design"><option value="">Elige un diseño</option></select></label></div><div class="kb-pack__wide" data-custom-field hidden><label>Referencia de tu diseño<input data-key="reference" maxlength="120" placeholder="Nombre o breve descripción"></label></div><div><label>Gramaje<select data-key="weight"><option value="180">180 g</option><option value="220">220 g</option><option value="250">250 g</option><option value="300">300 g</option></select></label></div><div><label>Color<select data-key="color"><option>Blanco</option><option>Negro</option></select></label></div><div class="kb-pack__wide"><label>Talla S–XL<select data-key="size"><option>S</option><option>M</option><option>L</option><option>XL</option></select></label></div></div><div class="kb-pack__qtyrow"><div><b>Cantidad</b><div class="kb-pack__stepper"><button type="button" data-step="-1" aria-label="Disminuir cantidad de prenda ${i + 1}">−</button><output>${x.qty}</output><button type="button" data-step="1" aria-label="Aumentar cantidad de prenda ${i + 1}">+</button></div></div><button type="button" class="kb-pack__remove" data-remove ${items.length === 1 ? 'disabled' : ''}>Eliminar prenda</button></div><p class="kb-pack__line" data-card-price></p></div></details>`;
    const cards = root.querySelector('[data-kb-pack-cards]');
    function render(message = '') {
      const active = document.activeElement, oldCard = active?.closest('[data-id]');
      const focusId = oldCard?.dataset.id, focusSelector = active?.matches('summary') ? 'summary' : active?.dataset.key ? `[data-key="${active.dataset.key}"]` : active?.hasAttribute('data-step') ? `[data-step="${active.dataset.step}"]` : active?.hasAttribute('data-remove') ? '[data-remove]' : null;
      const cursor = active?.tagName === 'INPUT' ? [active.selectionStart, active.selectionEnd] : null;
      cards.innerHTML = items.map(card).join('');
      let amount = 0;
      let usual = 0;
      let complete = assigned() === size && data.currency === 'MXN';
      let configured = 0;
      const rows = [];
      items.forEach((x, i) => {
        const el = cards.querySelector(`[data-id="${x.id}"]`);
        catalog.forEach(entry => {
          const option = document.createElement('option');
          option.value = String(entry.product.id);
          option.textContent = entry.product.title;
          el.querySelector('[data-key="design"]').append(option);
        });
        ['kind', 'design', 'reference', 'weight', 'color', 'size'].forEach(key => { el.querySelector(`[data-key="${key}"]`).value = x[key]; });
        el.querySelector('[data-catalog-field]').hidden = x.kind !== 'catalog';
        el.querySelector('[data-custom-field]').hidden = x.kind !== 'custom';
        const entry = catalog.find(z => String(z.product.id) === x.design);
        const product = x.kind === 'catalog' ? entry?.product : data.custom.find(z => z?.handle === `playera-personalizada-${x.weight}g`);
        const variant = product?.variants?.find(v => v.option1 === x.color && v.option2 === `${x.weight} g` && v.option3 === x.size && v.available);
        const eligible = Boolean(variant && (x.kind === 'custom' ? x.reference.trim() : entry?.discountVariantIds?.includes(variant.id)));
        if (!eligible) complete = false; else configured += x.qty;
        const name = x.kind === 'catalog' ? (product?.title || 'Diseño pendiente') : (x.reference.trim() || 'Personalizado');
        const image = product?.featured_image || product?.images?.[0];
        const thumb = el.querySelector('[data-thumb]');
        if (typeof image === 'string' && image.startsWith('https://')) {
          const img = document.createElement('img'); img.src = image; img.alt = ''; thumb.replaceChildren(img);
        } else thumb.style.background = x.color === 'Negro' ? '#444' : '#eee8df';
        el.querySelector('[data-card-desc]').textContent = `${name} · ${x.color} · ${x.size} · ${x.weight} g · ${x.qty}`;
        const unit = size === 4 ? Number(data.rates[x.weight]) : null;
        const line = unit === null ? null : x.qty * unit;
        if (line !== null) { amount += line; usual += x.qty * Number(data.usualRates[x.weight]); }
        el.querySelector('[data-card-price]').textContent = line === null ? 'Precio pendiente de aprobación' : `${x.qty} × ${money(unit)} = ${money(line)}`;
        rows.push({ name, color: x.color, size: x.size, weight: x.weight, qty: x.qty, line });
      });
      const count = assigned();
      const totalText = size === 4 ? money(amount) : 'Precio pendiente';
      root.querySelector('[data-builder-count]').textContent = `${configured} de ${size} configuradas`;
      root.querySelector('[data-counter]').textContent = `${configured} de ${size} configuradas`;
      root.querySelector('[data-add-card]').hidden = count >= size;
      root.querySelector('[data-total]').textContent = totalText;
      root.querySelector('[data-estimated-total]').textContent = totalText;
      const comparison = root.querySelector('[data-comparison]'); comparison.hidden = !complete || usual <= amount; if (!comparison.hidden) { const saved = usual - amount; const homogeneous = items.every(x => x.weight === items[0].weight); root.querySelector('[data-comparison-title]').textContent = homogeneous ? `PROMOCIÓN · ${size} PLAYERAS DE ${items[0].weight} G` : `PROMOCIÓN · ${size} PLAYERAS`; root.querySelector('[data-comparison-price]').firstChild.textContent = homogeneous ? `${money(Number(data.rates[items[0].weight]))} c/u · Total ` : 'Total del pack '; root.querySelector('[data-savings]').textContent = `Ahorras ${money(saved)} frente a comprarlas sin paquete`; root.querySelector('[data-comparison-detail]').textContent = homogeneous ? `Sin paquete: ${money(Number(data.usualRates[items[0].weight]))} c/u · ${money(usual)} las cuatro.` : `Sin paquete, estas mismas cuatro: ${money(usual)}. Con pack: ${money(amount)}.`; }
      root.querySelector('[data-feedback]').textContent = message || (count < size ? `Faltan ${size - count} prendas. Agrega otra o aumenta una cantidad.` : !complete ? `Configura ${size - configured} ${size - configured === 1 ? 'prenda' : 'prendas'} para completar tu bundle.` : 'Tu combinación está completa.');
      root.querySelector('[data-shipping]').textContent = !complete ? 'Configura las 4 playeras para revisar el envío.' : amount >= 1450 ? 'Alcanza el umbral estimado de envío normal gratis desde $1,450 después de descuentos. Express conserva su costo.' : `Faltan ${money(1450 - amount)} para envío normal gratis. Express conserva su costo.`;
      root.querySelector('[data-summary-lines]').replaceChildren(...rows.map(row => {
        const li = document.createElement('li'); const title = document.createElement('span'); title.textContent = `${row.qty} × ${row.name} · ${row.color} · ${row.size} · ${row.weight} g`; const value = document.createElement('b'); value.textContent = row.line === null ? 'Pendiente' : money(row.line); li.append(title, value); return li;
      }));
      root.querySelector('[data-cart-count]').textContent = `${count} de ${size} prendas`;
      root.querySelector('[data-cart-total]').textContent = complete ? totalText : 'Pendiente';
      root.querySelector('[data-cart-items]').replaceChildren(...rows.map(row => {
        const p = document.createElement('p'); const title = document.createElement('span'); title.textContent = `${row.qty} × ${row.name} · ${row.color} · ${row.size} · ${row.weight} g`; const value = document.createElement('b'); value.textContent = row.line === null ? 'Pendiente' : money(row.line); p.append(title, value); return p;
      }));
      if (!complete) root.querySelector('[data-cart-accordion]').open = true;
      if (focusId && focusSelector) { const replacement = cards.querySelector(`[data-id="${focusId}"] ${focusSelector}`); if (replacement) { replacement.focus(); if (cursor) replacement.setSelectionRange(...cursor); } else root.querySelector('[data-add-card]').focus(); }
    }
    const showFeedback = message => { root.querySelector('[data-feedback]').textContent = message; };
    cards.addEventListener('toggle', event => {
      const el = event.target.closest('[data-id]');
      if (el && event.target === el) { const x = items.find(z => z.id === Number(el.dataset.id)); if (x) x.open = el.open; el.querySelector('summary').setAttribute('aria-expanded', String(el.open)); }
    }, true);
    cards.addEventListener('input', event => {
      const el = event.target.closest('[data-id]'); if (!el) return;
      const x = items.find(z => z.id === Number(el.dataset.id)); const key = event.target.dataset.key; if (!key) return;
      x[key] = key === 'weight' ? Number(event.target.value) : event.target.value;
      render();
    });
    cards.addEventListener('change', event => { if (event.target.matches('select')) event.target.dispatchEvent(new Event('input', { bubbles: true })); });
    cards.addEventListener('click', event => {
      const el = event.target.closest('[data-id]'); if (!el) return;
      const x = items.find(z => z.id === Number(el.dataset.id));
      if (event.target.hasAttribute('data-step')) {
        const delta = Number(event.target.dataset.step);
        if (delta < 0 && x.qty === 1) return showFeedback('La cantidad mínima es 1. Para quitarla, usa «Eliminar prenda».');
        if (delta > 0 && assigned() >= size) return showFeedback('El pack está completo. Reduce otra cantidad antes de aumentar esta.');
        x.qty += delta; return render();
      }
      if (event.target.hasAttribute('data-remove')) {
        if (items.length === 1) return showFeedback('El pack necesita al menos una prenda.');
        items = items.filter(z => z !== x); render('Prenda eliminada. Reparte las unidades que faltan.');
      }
    });
    root.querySelector('[data-add-card]').addEventListener('click', () => {
      const remaining = size - assigned();
      if (remaining <= 0) return showFeedback('El pack está completo. Reduce una cantidad para agregar otra prenda.');
      items.forEach(x => x.open = false);
      items.push({ id: nextId++, qty: remaining, kind: 'catalog', design: '', reference: '', weight: 250, color: 'Blanco', size: 'M', open: true });
      render();
      cards.querySelector('[data-id]:last-child summary').focus();
    });
    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["katty-reviews-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kb-review-visual-picker')) {
    customElements.define('kb-review-visual-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.classList.add('is-enhanced');
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
        this.querySelectorAll('[data-review-accordion]').forEach(group => {
          const paths = Array.from(group.children).filter(child => child.matches('details[data-review-path]'));
          paths.forEach(path => {
            path.addEventListener('toggle', () => {
              if (path.open) paths.forEach(other => { if (other !== path) other.open = false; });
            });
          });
        });
        this.querySelectorAll('[data-review-search-scope]').forEach(scope => {
          const search = scope.querySelector('[data-review-search-input]');
          if (!search) return;
          search.addEventListener('input', () => {
            const query = normalize(search.value);
            let visible = 0;
            scope.querySelectorAll('[data-review-card]').forEach(card => {
              card.hidden = !normalize(card.dataset.reviewSearch).includes(query);
              if (!card.hidden) visible += 1;
            });
            scope.querySelectorAll('[data-review-group]').forEach(group => {
              group.hidden = !Array.from(group.querySelectorAll('[data-review-card]')).some(card => !card.hidden);
            });
            scope.querySelector('[data-review-no-results]').hidden = visible !== 0;
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["katty-style-drop-preview"]) return;
  try {
    
  const initializeStyleSort = () => {
    document.querySelectorAll('[data-style-drop-preview]').forEach(root => {
      const select = root.querySelector('[data-style-sort]');
      const grid = root.querySelector('[data-style-grid]');
      if (!select || !grid || select.dataset.ready === 'true') return;
      select.dataset.ready = 'true';
      const original = Array.from(grid.children).filter(child => child.classList.contains('kb-card'));
      const collectionLink = root.querySelector('[data-style-collection-link]');
      const initialSort = select.value;
      const locale = document.documentElement.lang || 'es';
      const comparators = {
        'title-ascending': (a, b) => a.dataset.styleTitle.localeCompare(b.dataset.styleTitle, locale),
        'title-descending': (a, b) => b.dataset.styleTitle.localeCompare(a.dataset.styleTitle, locale),
        'price-ascending': (a, b) => Number(a.dataset.kbSortPrice) - Number(b.dataset.kbSortPrice),
        'price-descending': (a, b) => Number(b.dataset.kbSortPrice) - Number(a.dataset.kbSortPrice),
        'created-ascending': (a, b) => Number(a.dataset.kbSortCreated) - Number(b.dataset.kbSortCreated),
        'created-descending': (a, b) => Number(b.dataset.kbSortCreated) - Number(a.dataset.kbSortCreated)
      };
      const updateSort = () => {
        const cards = [...original];
        const comparator = comparators[select.value];
        if (comparator) cards.sort(comparator);
        else if (select.value !== initialSort) return;
        cards.forEach(card => grid.appendChild(card));
        if (collectionLink) {
          const url = new URL(collectionLink.href, document.baseURI);
          url.searchParams.set('sort_by', select.value);
          collectionLink.href = url.toString();
        }
      };
      select.addEventListener('change', updateSort);
      updateSort();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeStyleSort, { once: true });
  else initializeStyleSort();
  document.addEventListener('shopify:section:load', initializeStyleSort);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["katty-urban-drop-preview"]) return;
  try {
    
  const initializeUrbanSort = () => {
    document.querySelectorAll('[data-urban-drop-preview]').forEach(root => {
      const select = root.querySelector('[data-urban-sort]');
      const grid = root.querySelector('[data-urban-grid]');
      if (!select || !grid || select.dataset.ready === 'true') return;
      select.dataset.ready = 'true';
      const original = Array.from(grid.children).filter(child => child.classList.contains('kb-card'));
      const collectionLink = root.querySelector('[data-urban-collection-link]');
      const initialSort = select.value;
      const locale = document.documentElement.lang || 'es';
      const comparators = {
        'title-ascending': (a, b) => a.dataset.urbanTitle.localeCompare(b.dataset.urbanTitle, locale),
        'title-descending': (a, b) => b.dataset.urbanTitle.localeCompare(a.dataset.urbanTitle, locale),
        'price-ascending': (a, b) => Number(a.dataset.kbSortPrice) - Number(b.dataset.kbSortPrice),
        'price-descending': (a, b) => Number(b.dataset.kbSortPrice) - Number(a.dataset.kbSortPrice),
        'created-ascending': (a, b) => Number(a.dataset.kbSortCreated) - Number(b.dataset.kbSortCreated),
        'created-descending': (a, b) => Number(b.dataset.kbSortCreated) - Number(a.dataset.kbSortCreated)
      };
      const updateSort = () => {
        const cards = [...original];
        const comparator = comparators[select.value];
        if (comparator) cards.sort(comparator);
        else if (select.value !== initialSort) return;
        cards.forEach(card => grid.appendChild(card));
        if (collectionLink) {
          const url = new URL(collectionLink.href, document.baseURI);
          url.searchParams.set('sort_by', select.value);
          collectionLink.href = url.toString();
        }
      };
      select.addEventListener('change', updateSort);
      updateSort();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeUrbanSort, { once: true });
  else initializeUrbanSort();
  document.addEventListener('shopify:section:load', initializeUrbanSort);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
